import { render } from "./FundsManagementFx.vue?vue&type=template&id=4975f027"
import script from "./FundsManagementFx.vue?vue&type=script&lang=js"
export * from "./FundsManagementFx.vue?vue&type=script&lang=js"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__